import { render } from "./EditorPageWrapper.vue?vue&type=template&id=30f2ed4a&scoped=true"
import script from "./EditorPageWrapper.vue?vue&type=script&lang=js"
export * from "./EditorPageWrapper.vue?vue&type=script&lang=js"

import "./EditorPageWrapper.vue?vue&type=style&index=0&id=30f2ed4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f2ed4a"]])

export default __exports__